import { ContentService, ImageService, ObserverService, PortfolioService,LessonService, ApiService } from '@DavisDigital/davisdigitalfrontend.module';
import { ContentModuleTypes, ContentModuleSubTypes, FolderTypes } from '../interfaces';
import * as IDavis from '@DavisDigital/interfaces';

class ImageUploadModalController {
	
	public contentModule: any;
	public contentModuleType: string;
	public collectionOptions: any[];
	public currentPage = 1;
	public files:any;
	public galleryLayout: string = 'single';
	public images: any[];
	public imageUploadEvent: string = 'uploadImageFiles';
	public k5AppropriateFlag: boolean = true;
	public keywords: string;
	public imageSetID: string;
	public lesson: any;
	public lessonId: string;
	public localImageMap = {};
	public editMode:boolean; 
	public isLoading = false;
	public imageUploadCreatedEntity = false;
	public portfolioPage:any;
	public portfolioPageId: string;
	public position: any;
	public saveEvent;
	public selectedCollection;
	public setEvent;
	public setEventData;
	public singleMode = true; 
	public selectedImages = [];
	public totalPages: any; 
	public type:string;

	private previouslyFocusedElement: HTMLElement | null = null;
	private focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

	// @ngInject
	constructor(
		public contentService	: ContentService, 
		public imageService		: ImageService,
		public observerService	: ObserverService,
		public portfolioService : PortfolioService,
		public lessonService : LessonService,
		private $q: 			ng.IQService,
		private apiService: 	ApiService,
		public ModalService,
		public $element,
		public $timeout			: ng.ITimeoutService
	){}
	
	public $onInit = () => {
		
		// Store the element that had focus before the modal opened
		if (!this.previouslyFocusedElement) {
			this.previouslyFocusedElement = document.activeElement as HTMLElement;
		}

		if(this.saveEvent == null){
			if(this.type === 'lesson'){
				this.saveEvent = 'saveLesson';
			} else { 
				this.saveEvent = 'savePortfolioPage';
			}
		} 
		if(this.setEvent == null){
			if(this.type === 'lesson'){
				this.setEvent  = 'setLesson';
			} else {
				this.setEvent  = 'setPortfolioPage';
			}
		} 
		
		this.editMode = this.type !== 'lesson';
		
		this.paginate(1);
		
		if( this.contentModuleType == null ){
			this.contentModuleType = 'cmtGallery';
		}
		
		this.singleMode = this.contentModuleType === 'cmtSplit';
		
		if( this.contentModule != null ){

			if( this.contentModule.contentModuleImages ){
				this.selectedImages = angular.copy(this.contentModule.contentModuleImages);
				this.editMode = true;
			}
			
			if( this.contentModule.primaryContentModuleImage_image_imageID &&
				this.contentModule.primaryContentModuleImage_image_imageID.trim().length
			){
				
				var image = this.imageService.getImage( this.contentModule.primaryContentModuleImage_image_imageID );
	
				if( image == null && 
					this.contentModule.primaryContentModuleImage_image_imageID in this.localImageMap
				){
					image = this.localImageMap[this.contentModule.primaryContentModuleImage_image_imageID];
				}
	
				var contentModuleImage = {
					contentModuleImageID : this.contentModule.primaryContentModuleImage_contentModuleImageID,
					image_imageID : this.contentModule.primaryContentModuleImage_image_imageID,
				}	
				
				if(image != null){
					contentModuleImage['daiCatalogNumber'] = image.daiCatalogNumber,
					contentModuleImage['image_s3PathToImageFile'] = image.s3PathToImageFile
				}
				
				this.selectedImages = [contentModuleImage];
				this.editMode = true;
				this.singleMode = true;
			}

		} else {
			this.contentModule = this.contentService.newContentModule(ContentModuleTypes.IMAGE, this.position);
		}
		
		this.imageService.getImageSets(1,20,'',true,[],'title',true).then((response)=>{
			this.collectionOptions = response.pages;
			this.collectionOptions.forEach(c => {
				if (!c.title || !c.title.trim()) { // if null/undefined/empty/white space
					c.title = "Unnamed Collection";
				}
			});
			this.collectionOptions.splice(0, 0, {title:'-- Select from your collections'});
			this.selectedCollection = this.collectionOptions[0];
		});
	
		this.observerService.attach(this.updateContentModuleImage,'contentModuleImageUpdated');
		this.observerService.attach(this.uploadFiles,this.imageUploadEvent);

		// Set initial focus to the close button after render
		this.$timeout(() => {
			const modalEl = this.$element[0].querySelector('.modal');
			if (modalEl) {
				modalEl.removeAttribute('aria-hidden');
				const closeBtn = modalEl.querySelector('.close') as HTMLElement;
				if (closeBtn) {
					closeBtn.focus();
				}
			}
		});
	}
	
	public updateContentModuleImage = (contentModuleImage: any) =>{
		for(var i=0; i<this.selectedImages.length; i++){
			if(contentModuleImage.contentModuleImageID === this.selectedImages[i].contentModuleImageID){
				this.selectedImages[i] = contentModuleImage;
				break; 
			}
		}
	}
	
	public paginate = (currentPage = this.currentPage) => {
		
		if(this.type === 'portfolioPage') return;
		
		this.currentPage = currentPage;
		this.totalPages = 0; 
		this.images = [];
		
		this.isLoading = true;
		
		this.imageService.getImages( this.currentPage, 12, this.keywords, this.k5AppropriateFlag ).then(
			(response) => {
				this.images = response.pages;
				this.totalPages = response.totalPages;
				this.isLoading = false; 
			}
		);
	}
	
	public goToEdit = () => {
		if (this.selectedImages.length) {
			this.editMode = true;
		}
	}

	public save = () =>{

		if (!this.selectedImages.length) return;
	
		this.contentModule.selectedImages = this.selectedImages;
		
		var eventName = 'updateContent';
		
		if( !this.contentModule.contentModuleID || 
			 this.contentModule.contentModuleID.length !== 32
		){
			if(this.contentModule.contentModuleType_systemCode === 'cmtSplit'){
				eventName = this.saveEvent;
			} else {
				eventName = 'addContent';
			}
		}
		
		if(this.lessonId && this.lessonId.length === 32 && !this.imageUploadCreatedEntity){
			this.observerService.notifyById( eventName, this.lessonId, this.contentModule);
		} else {
			this.observerService.notify( eventName, this.contentModule );
		}
		this.close();
	}
	
	private deselectAllImages = (imageID) =>{
		for(var i=0; i<this.images.length; i++){
			if(this.images[i]['imageID'] != imageID){
				this.images[i].selected = false; 
			}
		}
	}
	
	public selectImage = (image: any, index?:number) =>{
		
		if(index != null){
			
			image.selected = false;
			this.selectedImages.splice(index, 1);
			
			if(this.selectedImages.length === 1){
				this.contentModule.contentModuleSubType_systemCode = ContentModuleSubTypes.SINGLE;
			}
			
			return;
		}

		if(image.selected){
			
			if(this.singleMode){
				
				this.deselectAllImages(image.imageID);
				
				this.selectedImages = [];
			}
			
			this.selectedImages.push(image);
			
		} else {

			for(var i=0; i < this.selectedImages.length; i++){

				if( ( image.image_imageID != null && this.selectedImages[i].image_imageID === image.image_imageID ) ||
					( image.imageID != null && this.selectedImages[i].imageID === image.imageID)
				){
					this.selectedImages.splice(i,1);
					break;
				}
			}
		}
		
		if(this.selectedImages.length === 1){
			this.contentModule.contentModuleSubType_systemCode = ContentModuleSubTypes.SINGLE;
		} else if(this.selectedImages.length === 2) {
			this.contentModule.contentModuleSubType_systemCode = ContentModuleSubTypes.GRID;
		}
	}
	
	public selectGalleryLayout = (systemCode : ContentModuleSubTypes) =>{
		
		if(this.singleMode && systemCode !== ContentModuleSubTypes.SINGLE){
			return;
		}
		
		if(!this.singleMode && systemCode === ContentModuleSubTypes.SINGLE && this.selectedImages.length > 1){
			return;
		}
		
		this.contentModule.contentModuleSubType_systemCode = systemCode;
		
	}
	
	public handleSelectedCollection = (imageSetID) => {
	
		if(this.selectedCollection.imageSetID != null) {
			this.editMode = true;
		}
			this.imageService.getImageSetImages(this.selectedCollection.imageSetID,1,20,'',true,'title').then((response)=>{
			this.selectedImages = response.pages;
		});
	}
	
	public handleKeydown = (event: KeyboardEvent) => {
		if (event.key === 'Escape' || event.keyCode === 27) {
			event.preventDefault();
			this.close();
		}

		// Trap focus within the modal
		if (event.key === 'Tab' || event.keyCode === 9) {
			this.trapFocus(event);
		}
	}

	private trapFocus = (event: KeyboardEvent) => {
		const modalEl = this.$element[0].querySelector('.modal');
		if (!modalEl) return;

		const focusableElements = modalEl.querySelectorAll(this.focusableSelector);
		if (focusableElements.length === 0) return;

		const firstFocusable = focusableElements[0] as HTMLElement;
		const lastFocusable = focusableElements[focusableElements.length - 1] as HTMLElement;

		if (event.shiftKey) {
			if (document.activeElement === firstFocusable) {
				event.preventDefault();
				lastFocusable.focus();
			}
		} else {
			if (document.activeElement === lastFocusable) {
				event.preventDefault();
				firstFocusable.focus();
			}
		}
	}

	public switchTab = (editMode: boolean) => {
		this.editMode = editMode;
		// Move focus to the newly active tab
		this.$timeout(() => {
			const tabId = editMode ? 'EditImage-tab' : 'AddImage-tab';
			const tabEl = this.$element[0].querySelector('#' + tabId) as HTMLElement;
			if (tabEl) {
				tabEl.focus();
			}
		});
	}

	public handleTabKeydown = (event: KeyboardEvent, currentIsEdit: boolean) => {
		const key = event.key || event.keyCode;

		// Arrow Left/Right to switch between tabs (WAI-ARIA tabs pattern)
		if (key === 'ArrowRight' || key === 'ArrowLeft' || key === 39 || key === 37) {
			event.preventDefault();
			// Toggle to the other tab
			this.switchTab(!currentIsEdit);
		}

		// Home key - go to first tab
		if (key === 'Home' || key === 36) {
			event.preventDefault();
			this.switchTab(false);
		}

		// End key - go to last tab
		if (key === 'End' || key === 35) {
			event.preventDefault();
			this.switchTab(true);
		}
	}

	public close = () =>{
		if(this.imageUploadCreatedEntity){
			this.observerService.notify(this.setEvent, this.setEventData);
			this.imageUploadCreatedEntity = false;
		}
		this.ModalService.closeModals();

		// Restore focus to the previously focused element
		if (this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
			this.previouslyFocusedElement.focus();
		}
	}
	
	public uploadFiles = (args:any = {}, files: any = this.files) =>{
		
		if(args.portfolioPageID != null){
			this.portfolioPageId = args.portfolioPageID;
		}
		
		if(args.lessonID != null){
			this.lessonId = args.lessonID;	
		}
		
		let notifyId = this.lessonId?.length ? this.lessonId : this.portfolioPageId;
		let entityName = this.type;
		 
		this.contentModule.selectedImages = this.selectedImages;
		
		this.isLoading = true;
		

		if(entityName === 'portfolioPage' && this.portfolioPageId?.length !== 32){
			this.files = files;
			return this.portfolioService.getMyPortfolioFolders({ showAll: true })
	    	.then((result) => {
	    		this.isLoading = false;
	    		
	    		let allFolders = result.data.records;
	    		
	    		this.ModalService.showModal({
	    			component: 'saveAsModal',
	    			bodyClass: 'angular-modal-service-active',
	    			bindings: {
	    				type: FolderTypes.Portfolio,
	    				folders: allFolders,
	    				saveEvent: this.imageUploadEvent,
	    				setEvent: this.setEvent
	    			},
	    			preClose: (modal) => {
	    				modal.element.modal('hide');
	    			}
	    		}).then((modal) => {
	    			//it's a bootstrap element, use 'modal' to show it
	    			modal.element.modal('show');
	    			modal.close.then((result) => {});
	    			this.imageUploadCreatedEntity = true;
	    		});
	    	});
		}
		
		if(entityName === 'lesson' && this.lessonId?.length !== 32){
			this.files = files;
		    return this.lessonService.getMyLessonFolders({ showAll: true, ignoreArchiveFolder: true })
	    	.then((result) => {
	    		let allFolders = result.data.records;
	    		this.ModalService.showModal({
	    			component: 'saveAsModal',
	    			bodyClass: 'angular-modal-service-active',
	    			bindings: {
	    				type: FolderTypes.Lesson,
	    				folders: allFolders,
	    				saveEvent: this.imageUploadEvent,
	    				setEvent: this.setEvent,
	    				lesson: this.lesson
	    			},
	    			preClose: (modal) => {
	    				modal.element.modal('hide');
	    			},
	    		}).then((modal) => {
	    			//it's a bootstrap element, use 'modal' to show it
	    			modal.element.modal('show');
	    			modal.close.then((result) => {});
	    			this.imageUploadCreatedEntity = true;
	    		});
	    	});
		}
		this.imageService.uploadImageToContentModule(files, this.contentModule, notifyId, entityName).then(
			(response: any) => {
				
				if( response == null || 
					response.data == null || 
					response.data.data == null
				){
					this.isLoading = false; 
					return; 
				}
				
				if(response.data.data.success){
					
					if(response.data.data[entityName].imageMap){
						this.localImageMap = response.data.data[entityName].imageMap;
					}
					
					if(!this.imageUploadCreatedEntity){
						if(notifyId != null && notifyId.length && args !== {}){
							this.observerService.notifyById(this.setEvent, notifyId, response.data.data[entityName]);
						} else {
							this.observerService.notify(this.setEvent, response.data.data[entityName]);
						}
					} else {
						this.setEventData = response.data.data[entityName];
					}
					
					this.isLoading = false; 
					
					
					for(var i=0; i<response.data.data[entityName]['contentModules'].length; i++){
						
						var contentModule = response.data.data[entityName]['contentModules'][i];

						if(response.data.data['contentModule']['contentModuleID'] === contentModule['contentModuleID']){
							this.contentModule = contentModule;
							this.$onInit();
							this.editMode = true;
							break;
						}
					}
					
					//this.close();
				}
			},
			(reason: any) => {
				this.isLoading = false;
			}
		);
	}
	
	public launchModal = (modalName, image) =>{
		this.ModalService.showModal({
			component: modalName,
			bodyClass: 'angular-modal-service-active',
			bindings: {
                image : image,
                contentModule : this.contentModule,
                imageUploadModalController: this
			},
			preClose: (modal: any) => {
				modal.element.modal('hide');
			},
		}).then((modal: any) => {
			//it's a bootstrap element, use 'modal' to show it
			modal.element.modal('show');
			modal.close.then((result) => {});
		});
	}
	
	public launchImageCropperModal = (image: any) =>{
		this.launchModal('imageCropperModal', image);
	}
	
	public launchImageCaptionModal = (image: any) =>{
		this.launchModal('imageCaptionModal', image);
	}
	
	public launchImageDetailModal = (image: any) =>{
		this.launchModal('imageDetailModal', image);
	}
}

class ImageUploadModal {
	
	public restrict: string = 'E';
	public scope: boolean = true;
	
	public bindToController: any = {
		type:'=',
		contentModule:'=?',
		contentModuleType:'=?',
		lesson:'=?',
		lessonId:'=?',
		portfolioPage:'=?',
		portfolioPageId:'=?',
		position:'=',
		saveEvent:'=?',
		setEvent:'=?'
	};

	public controller = ImageUploadModalController;
	public controllerAs = 'imageUploadModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/image-upload-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { ImageUploadModal };
